export const ERROR_MASSAGES = {
    TRY_LATER: 'An error occurred, please try again later'
}